import React from 'react';

export const Label: React.FC<React.PropsWithChildren<{ mb?: string }>> = ({ children, mb = '4' }) => (
  <div className={'font-bold text-gray-700 ' + `mb-${mb}`}>{children}</div>
);
